import type { JSX } from 'cdui-js';
import { If, location } from 'cdui-js';
import i18n from '../../../i18n';
import { isFundHideNav } from '../deposit/h5-deposit/appBridge';
import { IconRecordsList } from './icons';
import { withStockTransferQuery } from './shared';

export type StockTransferNavProps = {
  title: string;
  onBack: () => void;
  onClose?: () => void;
  /**
   * 右上角「转股记录」。默认 true。
   * 记录列表页、从记录进入的详情页传 false。
   */
  showRecords?: boolean;
  /** 额外右侧内容（在记录按钮左侧） */
  right?: () => JSX.Element;
};

const IconBack = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M15 5L8 12L15 19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

const IconClose = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
  </svg>
);

const goRecords = () => {
  location.routeTo(withStockTransferQuery('/h5/stock-transfer-in/records'), [0, 0]);
};

/** App 已画顶栏（hideNav=1）时不渲染。浏览器单独打开仍用这套导航。 */
export const StockTransferNav = (props: StockTransferNavProps) => {
  const showRecords = props.showRecords !== false;

  return (
    <If when={!isFundHideNav()}>
      <div class="sti-nav">
        <button type="button" class="sti-nav-btn" onclick={props.onBack}>
          <IconBack />
        </button>
        <div class="sti-nav-title">{props.title}</div>
        <div class="sti-nav-side">
          <If when={!!props.right}>{props.right ? props.right() : null}</If>
          <If when={!!props.onClose}>
            <button type="button" class="sti-nav-btn" onclick={props.onClose} aria-label="close">
              <IconClose />
            </button>
          </If>
          <If when={showRecords}>
            <button
              type="button"
              class="sti-nav-btn sti-nav-records"
              aria-label={i18n.StockTransferIn.Records}
              onclick={goRecords}
            >
              <IconRecordsList />
            </button>
          </If>
        </div>
      </div>
    </If>
  );
};
